import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
import { CustomCursor } from './CustomCursor';
import { AnimatedSection } from './AnimatedSection';
import { ContactModal } from './ContactModal';
import { ProspectusModal } from './ProspectusModal';
import { TeamBioModal } from './TeamBioModal';
interface LayoutProps {
  children: ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col relative" data-id="element-106">
      <ScrollToTop data-id="element-107" />

      <CustomCursor data-id="element-108" />
      <ContactModal data-id="element-109" />
      <ProspectusModal data-id="element-110" />
      <TeamBioModal data-id="element-111" />
      <Navigation data-id="element-112" />
      <main className="flex-grow relative z-10" data-id="element-113">{children}</main>

      {/* Final CTA Section */}
      <div className="relative z-10 overflow-hidden" data-id="element-114">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: `url("https://cdn.magicpatterns.com/uploads/x6aTKnM8qE6DHMUbQsfWEp/IMG_3774.jpg")`
      }} data-id="element-115" />
        <div className="absolute inset-0 bg-brand-charcoal/80" data-id="element-116" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 text-center" data-id="element-117">
          <AnimatedSection data-id="element-118">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-cream mb-5" data-id="element-119">
              Take the next step
            </h2>
            <p className="text-brand-shape text-lg leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-120">
              Firetree offers funders curated access to established, highly
              effective local organizations with proven models in Southeast
              Asia.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-121">
              <button onClick={() => window.dispatchEvent(new CustomEvent('open-prospectus-modal'))} className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-brand-charcoal bg-brand-cream hover:bg-white transition-colors" data-id="element-122">
                Download Prospectus
              </button>
              <Link to="/engage#faq" className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-brand-cream border border-brand-cream/40 hover:border-brand-cream hover:bg-brand-cream/10 transition-colors" data-id="element-123">
                View FAQ
              </Link>
            </div>
          </AnimatedSection>
        </div>
      </div>

      <Footer data-id="element-124" />
    </div>;
}